import React from 'react'
import { useNavigate, useParams } from 'react-router'
import { useSelector } from 'react-redux'
import {
  userDealershipsSelector,
  userOrganizationsSelector,
} from '../../store/selectors/userSelector'
import { find } from 'lodash'
import { Outlet } from 'react-router-dom'
import { setDealership } from '../../store/reducers/dealershipReducer'
import Error404 from '../404'

const CheckAgencyAccess = (): JSX.Element => {
  const { agency_id } = useParams()
  const organizations = useSelector(userOrganizationsSelector)
  const navigate = useNavigate()

  const hasAccessToAgency = agency_id
    ? !!find(organizations, { id: parseInt(agency_id) })
    : false

  if (!hasAccessToAgency) {
    if (organizations && organizations.length) {
      const organization = organizations?.[0]
      setDealership(organization.dealerships?.[0])
      navigate(`/dashboard/agency/${organization?.id}`)
    } else {
      return <Error404 />
    }
  }

  return <Outlet />
}

export default CheckAgencyAccess
